<template>
  <div>

    <!-- 경영책임자 지시사항 / 안전보건 주요 일정-->
    <div class="dashboard-layout-2">
      <news-card v-if="getPermission(1002).r" title="경영책임자 지시사항" :boardId="1002" @clickPost="(_postId) => {
        this.$router.push({ path: `/project/${projectId}/announcement/businessnews/${_postId}` });
      }"/>
      <news-card v-if="getPermission(1003).r" title="안전보건 주요 일정" :boardId="1003" @clickPost="(_postId) => {
        this.$router.push({ path: `/project/${projectId}/announcement/schedule/${_postId}` });
      }"/>
    </div>

    <!-- 그 외 -->
    <div v-if="successLoadGraph && hasDashboardCharts" class="dashboard-layout-auto">
      <component v-for="chart in hasDashboardCharts" :is="getChart(chart)" :dataType="dataType" :key="chart"
                 :class="{'col-span-2': isMobile || chart === 'v-bar-chart305' || chart === 'v-bar-chart306'}"
      />
    </div>
  </div>
</template>

<script>
import include from '@/views/graph/include'
import NewsCard from "@/components/NewsCard.vue";

export default {
  components: {
    NewsCard,
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id || 2
    },
    /**
     * 화면 크기에 따른 모바일 여부 판단
     */
    isMobile() {
      return this.screenWidth <= 960
    },
    hasDashboardCharts () {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts
      if (hasDashboardCharts) {
        const list = []
        for (const chart of hasDashboardCharts) {
          if (chart.visible && Number(`${chart.project_id}`) === Number(`${this.projectId}`)) {
            const code = chart.dashboard_chart.code
            list.push(code)

            // 중대시민재해 분야의 경우 시설물현황과 원료제조물 사업장 두개로 분리
            if (code === "donut-chart01" && `${this.projectId}` === '5') {
              list.push('donut-chart21')
            }
          }
        }
        return list
      }

      return undefined
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    comGroupList () {
      const companyTree = this.$store.state.company.companyTree
      let maxDepth = 0;
      const list = []
      let hasRootHead = false
      const headList = []

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== 'undefined' && typeof com.descendant.com_type !== 'undefined' && com.descendant.com_type === 'head') {
            hasRootHead = true
            headList.push(com.descendant.com_name)
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth
          }

          const parentId = (com.descendant.parent_id) ? (com.descendant.parent_id) : com.descendant.id
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name
          } else {
            list[`com_${parentId}`] = {[com.descendant.id]: com.descendant.com_name}
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list
      }
    },
    dataType () {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return 'detail'
      }
      return 'company'
    },
    memberInfoBoards() {
      if (this.$store.state.member.memberInfo.boards) {
        return this.$store.state.member.memberInfo.boards
      } else {
        // 정보가 없으면, API에서 불러온다
        this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
      }
    },
  },
  data () {
    return {
      rootPath: '',
      successLoadGraph: false,
      alertList: [],
      screenWidth: 0
    }
  },
  async created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}`
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(() => {
      this.successLoadGraph = true
    });
  },
  async mounted () {
    await this.$store.dispatch('company/LOAD_COMPANY_TREE', {projectId: this.projectId})
    this.updateScreenWidth()
    window.addEventListener('resize', this.updateScreenWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth)
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    getChart (chart) {
      const chartComponent = chart.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('')
      return include[chartComponent]
    },
    getPermission(boardId) {
      if (!boardId || typeof boardId === 'object') {
        return {
          c: 0,
          r: 0,
          u: 0,
          d: 0,
          v: 0,
        }
      }
      const boards = this.memberInfoBoards;

      if (boards) {
        let board = boards.find((b) => parseInt(b.id) === boardId);

        if (!!board && !!board.pivot) {
          const pivot = { c: 0, r: 0, u: 0, d: 0, v: 0 };

          if (board.pivot.project_id) {
            board = boards.find((b) => b.pivot && parseInt(b.id) === parseInt(boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
            if (!!board && !!board.pivot) {
              return { ...board.pivot };
            } else {
              return pivot;
            }
          } else {
            return { ...board.pivot };
          }
        }
      }
      return {
        c: 0,
        r: 0,
        u: 0,
        d: 0,
        v: 0,
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .col-span-2 {
    grid-column: span 2 !important;
    @media (min-width: 960px) {
      grid-column: span 2 !important;
    }
    @media (min-width: 1310px) {
      grid-column: span 3 !important;
    }
    @media (min-width: 1660px) {
      grid-column: span 2 !important;
    }
  }
}
</style>
